import { render } from "./OpenRolesAccordion.vue?vue&type=template&id=14ef48c1&scoped=true"
import script from "./OpenRolesAccordion.vue?vue&type=script&lang=js"
export * from "./OpenRolesAccordion.vue?vue&type=script&lang=js"

import "./OpenRolesAccordion.vue?vue&type=style&index=0&id=14ef48c1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ef48c1"]])

export default __exports__